import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../config/firebase';
import LoginForm from './LoginForm';
import NotificationsDropdown from './NotificationsDropdown';
import './Header.css';

function Header() {
  const { currentUser, userData, logout } = useAuth();
  const [showLogin, setShowLogin] = useState(false);
  const [userProfile, setUserProfile] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    fetchUserProfile();
  }, [currentUser]);

  const fetchUserProfile = async () => {
    if (!currentUser) return;
    
    try {
      const profileDoc = await getDoc(doc(db, 'userProfiles', currentUser.uid));
      if (profileDoc.exists()) {
        setUserProfile(profileDoc.data());
      }
    } catch (error) {
      console.error('Error fetching user profile:', error);
    }
  };

  const handleLogout = async () => {
    try {
      await logout();
      navigate('/');
    } catch (error) {
      console.error('Failed to log out:', error);
    }
  };

  return (
    <header className="header">
      <div className="container">
        <Link to="/" className="logo">
          <h1>ChapterChat</h1>
          <span className="tagline">Your personal library</span>
        </Link>
        <nav className="nav">
          {currentUser ? (
            <>
              <Link to="/dashboard" className="nav-link">Dashboard</Link>
              <Link to="/friends" className="nav-link">Friends</Link>
              <Link to="/activity" className="nav-link">Activity</Link>
              <NotificationsDropdown />
              <div className="user-menu">
                <span className="user-greeting">
                  Hi, {userProfile?.displayName || currentUser?.displayName || currentUser?.email?.split('@')[0] || 'Reader'}!
                </span>
                <div className="user-dropdown">
                  <button className="user-menu-btn">
                    <div className="user-avatar">
                      {(userProfile?.displayName || currentUser?.displayName || currentUser?.email?.split('@')[0] || 'R').charAt(0).toUpperCase()}
                    </div>
                    <span className="dropdown-arrow">⌄</span>
                  </button>
                  <div className="dropdown-menu">
                    <Link to="/profile" className="dropdown-item">👤 Profile</Link>
                    <Link to="/settings" className="dropdown-item">⚙️ Settings</Link>
                    {(currentUser?.email === 'hadroncollides@gmail.com' || userData?.isAdmin) && (
                      <>
                        <hr className="dropdown-divider" />
                        <Link to="/admin" className="dropdown-item admin-link">🛡️ Admin Dashboard</Link>
                      </>
                    )}
                    <hr className="dropdown-divider" />
                    <button onClick={handleLogout} className="dropdown-item logout-btn">
                      🚪 Sign Out
                    </button>
                  </div>
                </div>
              </div>
            </>
          ) : (
            <>
              <Link to="/" className="nav-link">Home</Link>
              <Link to="/support" className="nav-link">Support</Link>
              <Link to="/contact" className="nav-link">Contact</Link>
              <button 
                onClick={() => setShowLogin(true)} 
                className="btn btn-primary btn-sm"
              >
                Sign In
              </button>
            </>
          )}
        </nav>
      </div>
      
      {showLogin && (
        <LoginForm onClose={() => setShowLogin(false)} />
      )}
    </header>
  );
}

export default Header;